import { Injectable } from '@angular/core';
import { Toast } from '../../shared/models/toast/toast.model';
import { ToastMode } from '../../shared/models/toast/toast-mode.enum';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: Toast[] = [];

  public show(message: string, mode?: ToastMode, delay?: number) {
    const toast: Toast = {
      message: message,
      mode: mode ?? ToastMode.Standard,
      delay: delay ?? 2000
    };
    this.toasts.push(toast);
    return toast;
  }

  public remove(toast: Toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  public clear() {
    this.toasts.splice(0, this.toasts.length);
  }
}
